import type { FormField } from '@cli-types/core-engine/schema.js'

export function createFormTitleField(label: string): FormField {
  return {
    name: 'title',
    type: 'text',
    label,
    required: true
  }
}
